import React, { Fragment } from "react";
import FriendCell from "components/Tribe/Friends/FriendsHome/FriendCell";
import FriendsMediaCard from "components/Project/StartProject/Step_3/FriendsCard";
import * as CONSTANT from "constants/text";
import ProjectPagination from "components/General/ProjectPagination";
import { paginate } from "utils/paginate";
import "./FriendListContainer.css";
import AxiosConfig from "axiosConfig";
//ref implementation of frontend/gui/src/components/Project/Home/ProjectGrid.js

class FriendListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requestPageSize: 6,
      invitationPageSize: 6,
      friendPageSize: 10,
      childRequestPageSize: 6,
      requestCurrentPage: 1,
      invitationCurrentPage: 1,
      childRequestCurrentPage: 1,
      currentRecommendedPage: 1,
      recommendedPageSize: 3,
      userId: undefined,
    };
  }

  componentDidMount() {
    AxiosConfig.get(`profile/details/`).then((res) => {
      this.setState({ userId: res.data.user_id });
    });
  }

  /**
   * Page change handler functions
   */
  handleRequestPageChange = (page) => {
    this.setState({ requestCurrentPage: page });
  };

  handleInvitationPageChange = (page) => {
    this.setState({ invitationCurrentPage: page });
  };

  handleChildRequestPageChange = (page) => {
    this.setState({ childRequestCurrentPage: page });
  };

  handleRecommendedPageChange = (page) => {
    this.setState({ currentRecommendedPage: page });
  };

  /**
   * Used for People You may know section to route the view button to back to the
   * FriendSearchHandler.js button handler for inviting.
   */
  searchResultViewClick(value) {
    this.props.searchResultViewClick(value);
  }

  /*****
   * Function for rendering the 4 different types of friend lists.
   */
  renderLists(props) {
    /////////////////////////////////////////////////////////////////////////////////////////
    //INVITATIONS
    //
    if (props.type === "Invitations") {
      const invitationListPaginated = paginate(
        props.friendLists,
        this.state.invitationCurrentPage,
        this.state.invitationPageSize
      );

      const friendCells = invitationListPaginated.map((elem, index) => (
        <FriendCell
          key={index}
          userName={elem.requester.full_name}
          friendSlug={elem.requester.username}
          buttonTitle={props.buttonTitle}
          profilePic={elem.requester.profile_pic}
          datePrefix={props.datePrefix}
          date={elem.created_at}
          buttonAction={() =>
            window.location.assign(
              `profile/${CONSTANT.RECEIVED}/${elem.id}/${elem.requester.username}/`
            )
          }
        />
      ));
      return (
        <Fragment>
          <div className="cell_container">{friendCells}</div>
          {props.friendLists.length <= this.state.invitationPageSize ? (
            null
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <ProjectPagination
                itemsCount={props.friendLists.length}
                pageSize={this.state.invitationPageSize}
                currentPage={this.state.invitationCurrentPage}
                onPageChange={this.handleInvitationPageChange}
              />
            </div>
          )}
        </Fragment>
      );
    }
    /////////////////////////////////////////////////////////////////////////////////////////
    //REQUESTS
    //
    else if (props.type === "Requests") {
      const requestListPaginated = paginate(
        props.friendLists,
        this.state.requestCurrentPage,
        this.state.requestPageSize
      );

      const friendCells = requestListPaginated.map((elem, index) => (
        <FriendCell
          key={index}
          userName={elem.requestee.full_name}
          friendSlug={elem.requestee.username}
          buttonTitle={props.buttonTitle}
          profilePic={elem.requestee.profile_pic}
          datePrefix={props.datePrefix}
          date={elem.created_at}
          buttonAction={() =>
            window.location.assign(
              `profile/${CONSTANT.REVIEW}/${elem.id}/${elem.requestee.username}/`
            )
          }
        />
      ));
      return (
        <Fragment>
          <div className="cell_container">{friendCells}</div>
          {props.friendLists.length <= this.state.requestPageSize ? (
            null
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <ProjectPagination
                itemsCount={props.friendLists.length}
                pageSize={this.state.requestPageSize}
                currentPage={this.state.requestCurrentPage}
                onPageChange={this.handleRequestPageChange}
              />
            </div>
          )}
        </Fragment>
      );
    }
    /////////////////////////////////////////////////////////////////////////////////////////
    //FRIENDS
    //
    else if (props.type === "Friends") {
      const friendListPaginated = paginate(
        props.friendLists,
        props.currentFriendPage,
        this.state.friendPageSize
      );

      const friendCells = friendListPaginated.map((elem, index) =>
        this.props.isFriendTribe === undefined ? (
          <FriendCell
            key={elem.friend.username}
            friendSlug={elem.friend.username}
            userName={elem.friend.full_name}
            profilePic={elem.friend.profile_pic}
            buttonTitle={props.buttonTitle}
            datePrefix={props.datePrefix}
            date={elem.created_at}
            buttonAction={() =>
              window.location.assign(
                `profile/${CONSTANT.FRIEND}/${elem.id}/${elem.friend.username}/`
              )
            }
          />
        ) : (
          <FriendCell
            key={elem.username}
            friendSlug={elem.username}
            userName={elem.full_name}
            profilePic={elem.profile_pic}
            buttonTitle={props.buttonTitle}
            buttonAction={() =>
              this.state.userId === elem.id
                ? (window.location.pathname = "/spotlight")
                : (window.location.pathname =
                    "profile/" +
                    CONSTANT.FRIEND +
                    "/" +
                    elem.id +
                    "/" +
                    elem.username +
                    "/")
            }
            isFriendTribe={this.props.isFriendTribe}
          />
        )
      );
      return (
        <Fragment>
          <div className="cell_container">{friendCells}</div>
          {props.friendLists.length <= this.state.friendPageSize ? null : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <ProjectPagination
                itemsCount={props.friendLists.length}
                pageSize={this.state.friendPageSize}
                currentPage={props.currentFriendPage}
                onPageChange={props.handleFriendPageChange}
              />
            </div>
          )}
        </Fragment>
      );
    }
    /////////////////////////////////////////////////////////////////////////////////////////
    //CHILD FRIEND REQUESTS (ManageChildTribe page)
    //
    else if (props.type === CONSTANT.CHILD_FRIEND_REQUESTS) {
      const childRequestListPaginated = paginate(
        props.friendLists,
        this.state.childRequestCurrentPage,
        this.state.childRequestPageSize
      );
      const friendCells = childRequestListPaginated.map((elem, index) =>
        elem.requestee ? (
          <FriendCell
            key={elem.requestee.username + elem.created_at}
            friendSlug={elem.requestee.username}
            userName={elem.requestee.full_name}
            profilePic={elem.requestee.profile_pic}
            buttonTitle={CONSTANT.BUTTON_VIEW_REQUEST}
            datePrefix={CONSTANT.PREFIX_SENT}
            date={elem.created_at}
            buttonAction={() =>
              window.location.assign(
                `profile/${props.child_username}/${CONSTANT.GUARDIAN_REVIEW}/${elem.id}/${elem.requestee.username}/`
              )
            }
          />
        ) : elem.requester.username!==props.child_username?(
          <FriendCell
            key={elem.requester.username}
            friendSlug={elem.requester.username}
            userName={elem.requester.full_name}
            profilePic={elem.requester.profile_pic}
            buttonTitle={CONSTANT.BUTTON_VIEW_INVITATION}
            datePrefix={CONSTANT.PREFIX_RECEIVED}
            date={elem.created_at}
            buttonAction={() =>
              window.location.assign(
                `profile/${props.child_username}/${CONSTANT.GUARDIAN_REVIEW}/${elem.id}/${elem.requester.username}/`
              )
            }
          />
        ):null
      );
      return (
        <Fragment>
          <div className="cell_container">{friendCells}</div>
          {props.friendLists.length <=
          this.state.childRequestPageSize ? null : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <ProjectPagination
                itemsCount={props.friendLists.length}
                pageSize={this.state.childRequestPageSize}
                currentPage={this.state.childRequestCurrentPage}
                onPageChange={this.handleChildRequestPageChange}
              />
            </div>
          )}
        </Fragment>
      );
    }
    /////////////////////////////////////////////////////////////////////////////////////////
    //RECOMMENDED FRIENDS (People You May Know section)
    //
    else if (props.type === CONSTANT.RECOMMENDATIONS) {
      const recommendationListPaginated = paginate(
        props.friendLists,
        this.state.currentRecommendedPage,
        this.state.recommendedPageSize
      );

      const friendCells = recommendationListPaginated.map((elem, index) => (
        <FriendsMediaCard
          key={elem.user_name}
          imageSrc={elem.user_photo}
          imageId={elem.user_name}
          imageName={elem.user_name}
          imageFullName = {elem.full_name}
          // location={elem.user_location}
          location=""
          searchResultInviteClick={this.searchResultViewClick.bind(this)}
          type={CONSTANT.RECOMMENDATIONS}
        />
      ));
      return (
        <Fragment>
          <div className="mt-15"><div className="recommended_friend_container">{friendCells}</div></div>
          {props.friendLists.length <= this.state.recommendedPageSize ? null : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <ProjectPagination
                itemsCount={props.friendLists.length}
                pageSize={this.state.recommendedPageSize}
                currentPage={this.state.currentRecommendedPage}
                onPageChange={this.handleRecommendedPageChange}
              />
            </div>
          )}
        </Fragment>
      );
    }
  }

  render() {
    return this.renderLists(this.props);
  }
}

export default FriendListContainer;
